module.exports = __webpack_public_path__ + "static/media/pin_img.5ce7ed86.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pin_img.svg
// module id = 660
// module chunks = 7